import { useRef, useContext } from "react";
import { ChevronDownSvg } from "../../icons/Icon";
import { viewTagsByVariantIdEvent } from "../../events/VariantEditorEvents";
import { useEventContext } from "../../contexts/EventContextProvider";
import VariantTagsDisplayBar from "./VariantTagsDisplayBar";
import { PlaceholderContext } from "../../contexts/Contexts";
import {
    removeAllTagsByVariantIdEvent,
    enableEditEvent,
    enableDeleteEvent
} from "../../events/VariantEditorEvents";
import { Dialog } from "../modal/Dialog";

const VariantList = ({ items, editAction, onCheck, checked }) => {

    const { state, eventDispatch } = useEventContext();
    const placeholder = useContext(PlaceholderContext);
    const rows = useRef({});

    const onMultiSelectChange = (e) => {
        console.log('onMultiSelectChange', e);
    }
    const onDelete = (e, o) => {
        e.preventDefault();
        //console.log('onDelete', e, o)

        placeholder.openModal(<Dialog><div>Delete all tags from variant "<b>{o.name}</b>" ?</div></Dialog>, {
            onApprove: (a) => {
                removeAllTagsByVariantIdEvent(o?.id || null);
                a.actions.close();
            }
        }, {
            heading: 'Confirm delete',
            message: ''
        })
    };

    return (
        <div className="filter-list">
            {items &&
                items.map((item) => {
                    return (
                        <div key={`variant-tag-${item.id}`} className={`StickerItem ${checked[item.id] ? 'CollectionList_SelectedRow' : ''}`}>
                            <div className="flex-column">
                                <div className="flex-row">
                                    <div className="col-1 flex-center">
                                        <label className="StickerItem_label">
                                            <div className="StickerItem_tag">
                                                <input
                                                    type="checkbox"
                                                    name="variant"
                                                    onChange={(e) => onCheck(e, item)}
                                                    checked={checked[item.id] || false}
                                                />
                                            </div>
                                        </label>
                                    </div>
                                    <div className="col-19 flex-middle">
                                        <div className="StickerItem_tag">
                                            <span>{item.name}</span>
                                        </div>
                                    </div>
                                    <div className="col-3 flex-middle">
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(enableEditEvent(item))}><span>edit</span></button>
                                            <button onClick={(e) => onDelete(e, item)}><span>delete</span></button>
                                        </div>
                                    </div>
                                    <div className="col-1 flex-middle">
                                        <div className="StickerItem_controls" >
                                            <button onClick={(e) => eventDispatch(viewTagsByVariantIdEvent(item.id))}><span><ChevronDownSvg /></span></button>
                                        </div>
                                    </div>
                                </div>
                                <VariantTagsDisplayBar id={item.id} ref={(current => { rows.current[item.id] = current })} />
                            </div>
                        </div>
                    );
                })}
        </div>
    );
}

export default VariantList;